export const isNumber = (value: any) => {
  if (!value || value === '' || value === null) return false
  const numberRegex = /^[0-9]*$/
  return numberRegex.test(value)
}

export default isNumber
